import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useEnrollmentContext } from "@/state";

export const useConsistentClient = () => {
  const experienceData = useEnrollmentContext();
  const navigate = useNavigate();

  const urlLocation = window.location;
  const pathname = urlLocation.pathname;
  const searchParams = new URLSearchParams(urlLocation.search);
  const clientName = searchParams.get("client");
  const enrollmentPlan = searchParams.get("enrollmentPlan");

  useEffect(() => {
    const plans = experienceData.plan_csids;
    const planOnClient = plans.some((plan) => plan.id === Number(enrollmentPlan));

    if (!planOnClient && clientName) navigate({ pathname, search: `client=${clientName}` });
  }, [navigate, clientName, enrollmentPlan, experienceData]);
};
